import { FunctionComponent, FormEvent } from 'react';
import classnames from 'classnames';
import Checkbox from '@media-ui/core/src/components/Checkbox';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';
import { FormFieldProps } from '../FormField/FormField.types';
import * as s from './PetsCheckbox.css';
const PetsInput: FunctionComponent<FormFieldProps> = ({ label, name, required, children, theme, }) => {
    const { getValues, setValue } = useFormContext();
    const valueFromForm = getValues(name);
    const checkboxClasses = classnames(s.checkbox, {
        [s.petsshop]: theme === 'petsshop',
    });
    return (<FormField required={required} label={label} name={name}>
      <Checkbox onChange={(e: FormEvent<HTMLInputElement>): void => setValue(name, (e.target as HTMLInputElement).checked)} className={checkboxClasses} value={valueFromForm} checked={valueFromForm} name={name}>
        {children}
      </Checkbox>
    </FormField>);
};
export default PetsInput;
